import { z } from 'zod';
import * as FlatModels from '../../internal';

export const BasePipeObjectSchema = z.object({
	data: z.any(),
});

//<editor-fold desc="Annotations">

export const BaseAnnotationPipeObjectSchema = BasePipeObjectSchema.extend({
  type: z.string(),
	annotation: FlatModels.AnnotationEntityModels.AnnotationEntityTypeSchema,
	label: FlatModels.AnnotationLabelEntityModels.AnnotationLabelSchema.optional(),
	source: FlatModels.AnnotationSourceEntityModels.AnnotationSourceSchema.optional(),
});

//<editor-fold desc="Marker">

export const MarkerPipeObjectSchema = BaseAnnotationPipeObjectSchema.extend({
  type: z.literal('Marker'),
	annotation: FlatModels.AnnotationEntityModels.MarkerSchema,
	targets: z.array(FlatModels.AnnotationTargetEntityModels.AnnotationTargetSchema).optional(),
});

export type MarkerPipeObject = z.infer<typeof MarkerPipeObjectSchema>;

//</editor-fold>

//<editor-fold desc="Text">

export const TextPipeObjectSchema = MarkerPipeObjectSchema.extend({
  type: z.literal('Text'),
  annotation: FlatModels.AnnotationEntityModels.TextSchema,
});

export type TextPipeObject = z.infer<typeof TextPipeObjectSchema>;

//</editor-fold>

//<editor-fold desc="Free Form">

export const FreeFormPipeObjectSchema = BaseAnnotationPipeObjectSchema.extend({
  type: z.literal('FreeForm'),
	annotation: FlatModels.AnnotationEntityModels.FreeFormSchema,
	target: FlatModels.AnnotationTargetEntityModels.AnnotationTargetSchema.optional(),
	freeFormStyle: FlatModels.FreeFormStyleEntityModels.FreeFormStyleSchema.optional(),
});

export type FreeFormPipeObject = z.infer<typeof FreeFormPipeObjectSchema>;

//</editor-fold>

//<editor-fold desc="Keymap">

export const KeymapLabelPipeObjectSchema = BasePipeObjectSchema.extend({
	keymapLabel: FlatModels.KeymapLabelEntityModels.KeymapLabelSchema,
	annotation: FlatModels.AnnotationEntityModels.AnnotationEntityTypeSchema.optional(),
});

export type KeymapLabelPipeObject = z.infer<typeof KeymapLabelPipeObjectSchema>;

export const KeymapColumnPipeObjectSchema = BasePipeObjectSchema.extend({
	keymapColumn: FlatModels.KeymapColumnEntityModels.KeymapColumnSchema,
	labels: z.array(KeymapLabelPipeObjectSchema).optional(),
});

export type KeymapColumnPipeObject = z.infer<typeof KeymapColumnPipeObjectSchema>;

export const KeymapPipeObjectSchema = BaseAnnotationPipeObjectSchema.extend({
  type: z.literal('Keymap'),
	annotation: FlatModels.AnnotationEntityModels.KeymapSchema,
	keymapStyle: FlatModels.KeymapStyleEntityModels.KeymapStyleSchema.optional(),
	columns: z.array(KeymapColumnPipeObjectSchema).optional(),
});

export type KeymapPipeObject = z.infer<typeof KeymapPipeObjectSchema>;

//</editor-fold>

export const AnnotationPipeObjectSchema = z.discriminatedUnion('type', [MarkerPipeObjectSchema, TextPipeObjectSchema, FreeFormPipeObjectSchema, KeymapPipeObjectSchema]);

export type AnnotationPipeObject = z.infer<typeof AnnotationPipeObjectSchema>;

//</editor-fold>

//<editor-fold desc="Pois">

export const PointOfInterestPipeObjectSchema = BasePipeObjectSchema.extend({
	poi: FlatModels.PointOfInterestEntityModels.PointOfInterestSchema,
});

export type PointOfInterestPipeObject = z.infer<typeof PointOfInterestPipeObjectSchema>;

//</editor-fold>

//<editor-fold desc="Images">

export const ImagePipeObjectSchema = BasePipeObjectSchema.extend({
	image: FlatModels.ImageEntityModels.ImageSchema,
	annotations: z.array(AnnotationPipeObjectSchema).optional(),
	pois: z.array(PointOfInterestPipeObjectSchema).optional(),
});

export type ImagePipeObject = z.infer<typeof ImagePipeObjectSchema>;

//</editor-fold>

//<editor-fold desc="Layers">

export const LayerPipeObjectSchema = BasePipeObjectSchema.extend({
	layer: FlatModels.LayerEntityModels.LayerSchema,
	images: z.array(FlatModels.ImageEntityModels.ImageSchema).optional(),
});

export type LayerPipeObject = z.infer<typeof LayerPipeObjectSchema>;

//</editor-fold>